export interface AccessTokenPayload {
  sub: string;
  ifor: string;
  iat: number;
  exp: number;
  code: string;
  user_uid: string;
  refresh_token: string;
  refresh_token_expiration: number;
  reset_password_required: boolean;
  otp_confirmation_required: boolean;
}

export function decodeAccessToken(token: string | null | undefined): AccessTokenPayload | null {
  const payload = token?.split('.')[1];
  if (!payload) {
    return null;
  }
  try {
    return JSON.parse(atob(payload)) as AccessTokenPayload;
  } catch {
    return null;
  }
}
